import { defineComponent as _defineComponent } from 'vue';
import { GChart } from 'vue-google-charts';

// TODO: this part is duplicated!!!
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { editableFundReportAdditionalInfo } from '~/assets/fund/periodicReport';
import { renderMarkdown } from '~/functions/markdown';
import { getLocale } from '~/functions/translate';
export default /*#__PURE__*/_defineComponent({
  __name: 'fossilOrNuclear',
  props: {
    // calculatedSfdrReport: { type: Object, required: true },
    percentageOfInvestmentsAlignedWithEuTaxonomy: {
      type: Object,
      required: true
    },
    hasAlignedEnvironmentalInvestments: {
      type: Boolean,
      required: true
    },
    hasFossilOrNuclearActivities: {
      type: Boolean,
      required: true
    },
    hasFossilActivities: {
      type: Boolean,
      required: true
    },
    hasNuclearActivities: {
      type: Boolean,
      required: true
    },
    hasNoFossilNorNuclearActivities: {
      type: Boolean,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var locale = computed(function () {
      return getLocale();
    });
    var treeviewMapping = {
      yes: {
        en: 'Yes',
        de: 'Ja'
      },
      no: {
        en: 'No',
        de: 'Nein'
      },
      inFossilGas: {
        en: 'In fossil gas',
        de: 'In fossil Gas'
      },
      inNuclearEnergy: {
        en: 'In nuclear energy',
        de: 'In Kernenergie'
      }
    };
    var alignedInvestmentsTreeview = computed(function () {
      return [{
        id: 'hasFossilOrNuclearActivities',
        name: treeviewMapping.yes[locale.value],
        disabled: !props.hasAlignedEnvironmentalInvestments,
        selected: props.hasFossilOrNuclearActivities,
        children: [{
          id: 'hasFossilActivities',
          name: treeviewMapping.inFossilGas[locale.value],
          disabled: !props.hasAlignedEnvironmentalInvestments,
          selected: props.hasFossilActivities
        }, {
          id: 'hasNuclearActivites',
          name: treeviewMapping.inNuclearEnergy[locale.value],
          disabled: !props.hasAlignedEnvironmentalInvestments,
          selected: props.hasNuclearActivities
        }]
      }, {
        id: 'hasNoFossilNorNuclearActivities',
        name: treeviewMapping.no[locale.value],
        disabled: !props.hasAlignedEnvironmentalInvestments,
        selected: props.hasNoFossilNorNuclearActivities
      }];
    });
    var investmentsAlignedWithEuTaxonomyChartOptions = function investmentsAlignedWithEuTaxonomyChartOptions(title) {
      var options = {
        title: title,
        hAxis: {
          minValue: 0
        },
        width: 450,
        height: 300,
        isStacked: 'percent',
        legend: 'none',
        colors: ['#809c7c', '#50744c', '#083404', '#e0dcdc']
      };
      return options;
    };
    return {
      __sfc: true,
      props: props,
      locale: locale,
      treeviewMapping: treeviewMapping,
      alignedInvestmentsTreeview: alignedInvestmentsTreeview,
      investmentsAlignedWithEuTaxonomyChartOptions: investmentsAlignedWithEuTaxonomyChartOptions,
      GChart: GChart,
      editableFundReportAdditionalInfo: editableFundReportAdditionalInfo,
      renderMarkdown: renderMarkdown
    };
  }
});